module.exports = __webpack_public_path__ + "static/img/4.a8c6327.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/4/4.png
// module id = cZ80
// module chunks = 0